/**
 * Kadr rysunku technicznego w sekcji "Parametry techniczne".
 *
 * Pod jednym metapolem (`custom.parameter_image`, a czesciej adres {img:...}
 * w tekscie parametrow) katalog trzyma DWA rozne rodzaje plikow:
 *   - rysunki techniczne z wymiarowaniem - wysokosc do 1,3 szerokosci (93 pliki),
 *   - pionowe PLANSZE materacy - cala specyfikacja jako jeden obraz, wysokosc
 *     okolo 4,3 szerokosci (8 plikow, np. 1431 x 6135).
 *
 * Plansza w roli rysunku obok tabeli rosla do ponad 3000 px: sekcja wygladala
 * jak samotny naglowek i kilometr obrazka. Kadr jest wiec ograniczony wysokoscia
 * (arkusz), a ten skrypt robi dwie rzeczy:
 *   1. mierzy proporcje pliku i dla planszy przelacza sekcje w uklad jednokolumnowy
 *      (tabela na pelnej szerokosci, plansza pod nia, wysrodkowana),
 *   2. dokłada przycisk rozwiniecia TYLKO wtedy, gdy kadr naprawde obcina obraz.
 *
 * Proporcji nie da sie policzyc w Liquidzie dla adresu wpisanego w tekst - stad
 * pomiar po stronie przegladarki. Gdy wymiary sa znane z metapola, klase trybu
 * ustawia juz Liquid i nie ma przeskoku ukladu.
 */
if (!customElements.get('pdp-params-figure')) {
  class PdpParamsFigure extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('img');
      this.frame = this.querySelector('.pdp-params__frame');
      if (!this.img || !this.frame) return;

      this.tallRatio = parseFloat(this.dataset.tallRatio) || 1.6;
      this.expanded = false;
      this.update = this.update.bind(this);

      if (this.img.complete && this.img.naturalWidth) {
        this.measure();
      } else {
        this.img.addEventListener('load', () => this.measure(), { once: true });
      }

      // Kadr obcina rozna ilosc przy roznych szerokosciach okna, wiec przycisk
      // moze byc potrzebny dopiero po zmianie rozmiaru (albo przestac byc).
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.frame);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    measure() {
      const width = this.img.naturalWidth;
      const height = this.img.naturalHeight;
      if (!width || !height) return;

      if (height / width > this.tallRatio) {
        const section = this.closest('.pdp-params');
        if (section) section.classList.add('pdp-params--tall');
      }
      this.update();
    }

    update() {
      if (this.expanded) return;
      const clipped = this.frame.scrollHeight - this.frame.clientHeight > 2;
      if (clipped) {
        this.ensureToggle();
      } else if (this.toggle) {
        this.toggle.hidden = true;
        this.classList.remove('pdp-params__figure--clipped');
      }
    }

    ensureToggle() {
      this.classList.add('pdp-params__figure--clipped');
      if (this.toggle) {
        this.toggle.hidden = false;
        return;
      }
      this.toggle = document.createElement('button');
      this.toggle.type = 'button';
      this.toggle.className = 'pdp-params__toggle';
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggle.textContent = this.dataset.labelExpand || 'Pokaż całość';
      this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));
      this.appendChild(this.toggle);
    }

    setExpanded(next) {
      this.expanded = next;
      this.classList.toggle('is-expanded', next);
      this.toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
      this.toggle.textContent = next
        ? this.dataset.labelCollapse || 'Zwiń'
        : this.dataset.labelExpand || 'Pokaż całość';

      // Po zwinieciu gora kadru moze uciec nad ekran - wracamy do niej, zeby
      // klikniecie "Zwin" nie zostawialo kupujacego w polowie nastepnej sekcji.
      if (!next) {
        const top = this.getBoundingClientRect().top;
        if (top < 0) {
          this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        this.update();
      }
    }
  }

  customElements.define('pdp-params-figure', PdpParamsFigure);
}
